// extracted by mini-css-extract-plugin
module.exports = {"container":"_025a50318d--container--1c8AR","title":"_025a50318d--title--1SuYs"};